<div *ngIf="horizontalMenu" class="navbar-header d-xl-block d-none">
  <!-- Navbar brand -->
  <ul class="nav navbar-nav flex-row">
    <li class="nav-item">
      <a class="navbar-brand" [routerLink]="['/']">
        <span class="brand-logo">
          <img
            src="{{ coreConfig.app.appLogoImage }}"
            alt="brand-logo"
            width="36"
          />
        </span>
        <!--<h2 class="brand-text mb-0">{{ coreConfig.app.appName }}</h2>-->
      </a>
    </li>
  </ul>
  <!--/ Navbar brand -->
</div>

<div class="navbar-container d-flex content">
  <div class="bookmark-wrapper d-flex align-items-center">
    <!-- Menu Toggler | Menu icon will be hidden in case of layout without menu -->
    <ul class="nav navbar-nav d-xl-none" *ngIf="!coreConfig.layout.menu.hidden">
      <li class="nav-item">
        <a class="nav-link menu-toggle" (click)="toggleSidebar('menu')">
          <span [data-feather]="'menu'" [class]="'ficon'"></span>
        </a>
      </li>
    </ul>
    <!--/ Menu Toggler -->
    <!--/ Toggle skin -->
  </div>

  <li
    class="nav-item d-none d-lg-block action"
    (click)="openPlanPrivisioning()"
    ngbTooltip="Ver plan"
    *ngIf="subscription"
  >
    <div class="media">
      <div class="avatar bg-light-primary mr-2">
        <div
          [ngClass]="currentSkin === 'dark' ? 'dark-content' : ''"
          class="avatar-content"
        >
          <i class="fas fa-wallet"></i>
        </div>
      </div>
      <div class="media-body my-auto">
        <h4 class="font-weight-bolder mb-0">{{ subscription.plan?.name }}</h4>
        <p class="card-text font-small-3 mb-0">Plan</p>
      </div>
    </div>
  </li>

  <!-- <li class="ml-2 nav-item d-none d-lg-block" *ngIf="subscription">
    <div class="media">
      <div class="avatar bg-light-primary mr-2">
        <div [ngClass]="currentSkin === 'dark' ? 'dark-content' : ''" class="avatar-content">
          <i data-feather="mail" class="avatar-icon"></i>
        </div>
      </div>
      <div *ngIf="subscription.enable_extra_sms === 1">
        <div class="media-body my-auto" *ngIf="subscription?.extra_sms_unlimited === 0">
          <h4 class="font-weight-bolder mb-0">{{subscription?.Plan?.total_messages | number}}</h4>
        </div>
        <div class="media-body my-auto" *ngIf="subscription.extra_sms_unlimited === 1">
          <div class="badge badge-light-primary">Ilimitado</div>
        </div>
      </div>
      <div *ngIf="subscription.enable_extra_sms === 0" style="margin-top: 5px">
        <span class="badge badge-light-primary">Sin excendentes</span>
      </div>
    </div>
  </li> -->

  <li
    class="ml-2 nav-item d-none d-lg-block action"
    (click)="openPlanConsumption()"
    ngbTooltip="Ver resumen de consumo"
    *ngIf="subscription"
  >
    <div class="media">
      <div class="avatar bg-light-primary mr-2">
        <div
          [ngClass]="currentSkin === 'dark' ? 'dark-content' : ''"
          class="avatar-content"
        >
          <i data-feather="send" class="avatar-icon"></i>
        </div>
      </div>
      <div class="media-body my-auto">
        <h4 class="font-weight-bolder mb-0">
          {{ subscription?.total_messages | number }}
        </h4>
        <p class="card-text font-small-3 mb-0">Mensajes consumidos</p>
      </div>
    </div>
  </li>

  <li class="ml-2 nav-item d-none d-lg-block" *ngIf="subscription">
    <div class="media">
      <div class="avatar bg-light-primary mr-2">
        <div
          [ngClass]="currentSkin === 'dark' ? 'dark-content' : ''"
          class="avatar-content"
        >
          <i data-feather="calendar" class="avatar-icon"></i>
        </div>
      </div>
      <div class="media-body my-auto">
        <h4 class="font-weight-bolder mb-0">
          {{ getNextInvoiceDate(subscription?.consumption_receipt_date) }}
        </h4>
        <p class="card-text font-small-3 mb-0">Próximo corte</p>
      </div>
    </div>
  </li>

  <ul class="nav navbar-nav align-items-center ml-auto">
    <!-- ? Language selection | Uncomment if needed-->
    <!-- <li ngbDropdown class="nav-item dropdown dropdown-language">
      <a class="nav-link dropdown-toggle" id="dropdown-flag" ngbDropdownToggle>
        <i class="flag-icon flag-icon-{{ languageOptions[_translateService.currentLang].flag }}"></i
        ><span class="selected-language">{{ languageOptions[_translateService.currentLang].title }}</span></a
      >
      <div ngbDropdownMenu aria-labelledby="dropdown-flag">
        <a *ngFor="let lang of _translateService.getLangs()" ngbDropdownItem (click)="setLanguage(lang)">
          <i class="flag-icon flag-icon-{{ languageOptions[lang].flag }}"></i> {{ languageOptions[lang].title }}
        </a>
      </div>
    </li> -->
    <!--/ Language selection -->
    <!-- Toggle skin -->
    <app-tz-details></app-tz-details>

    <li (click)="openHubSpotForm()" class="nav-item d-none d-lg-block">
      <i
        [ngbTooltip]="tooltipSupportTitle"
        class="action font-medium-5 fa-solid fa-headset"
      ></i>
    </li>

    <help-global-button></help-global-button>

    <app-navbar-notification></app-navbar-notification>
    <!-- User Dropdown -->
    <li ngbDropdown class="nav-item dropdown-user">
      <a
        class="nav-link dropdown-toggle dropdown-user-link"
        id="dropdown-user"
        ngbDropdownToggle
        id="navbarUserDropdown"
        aria-haspopup="true"
        aria-expanded="false"
        style="align-items: baseline"
      >
        <div class="user-nav d-sm-flex d-none">
          <span
            class="user-name font-weight-bolder"
            style="font-size: 12px !important"
            >{{ user?.username }}</span
          >
          <span class="user-status" style="font-size: 10px">{{
            roleName(user?.role)
          }}</span>
        </div>
        <div class="avatar bg-light-info">
          <span
            [ngClass]="currentSkin === 'dark' ? 'dark-content' : ''"
            class="avatar-content"
            >{{ this.getInitials() }}</span
          >
          <span class="avatar-status-online"></span>
        </div>
      </a>
      <div
        ngbDropdownMenu
        aria-labelledby="navbarUserDropdown"
        class="dropdown-menu dropdown-menu-right"
      >
        <a ngbDropdownItem [routerLink]="['/perfil']"
          ><span [data-feather]="'user'" [class]="'mr-50'"></span> Perfil</a
        >
        <a
          *ngIf="isSender"
          ngbDropdownItem
          [routerLink]="['/resumen/plan-consumido']"
          ><span [data-feather]="'pie-chart'" [class]="'mr-50'"></span>
          Consumo</a
        >
        <!-- <a ngbDropdownItem [routerLink]="['/perfil/notificaciones']"
          ><span [data-feather]="'pie-chart'" [class]="'mr-50'"></span>
          Notificaciones</a
        > -->
        <!--<a ngbDropdownItem [routerLink]="['/']"><span [data-feather]="'mail'" [class]="'mr-50'"></span> Inbox</a
        ><a ngbDropdownItem [routerLink]="['/']"><span [data-feather]="'check-square'" [class]="'mr-50'"></span> Task</a
        ><a ngbDropdownItem [routerLink]="['/']"
          ><span [data-feather]="'message-square'" [class]="'mr-50'"></span> Chats</a
        > -->
        <div class="dropdown-divider"></div>
        <a ngbDropdownItem (click)="logout()"
          ><span [data-feather]="'power'" [class]="'mr-50'"></span> Logout</a
        >
      </div>
    </li>
    <!--/ User Dropdown -->
  </ul>
</div>
